/*eslint-disable*/
import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Checkbox from "@material-ui/core/Checkbox";
import InputAdornment from "@material-ui/core/InputAdornment";

// material ui icons
import MailOutline from "@material-ui/icons/MailOutline";
import Contacts from "@material-ui/icons/Contacts";
import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardText from "components/Card/CardText.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import axios from "../../utils/axiosInstance"; 
import CardFooter from "components/Card/CardFooter.js";
import SweetAlert from "react-bootstrap-sweetalert";
// style for this view
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
//const baseURL = "https://jsonplaceholder.typicode.com/api/v1/admin/login";
const useStyleData = makeStyles(stylesData);
const useStyles = makeStyles(styles);

export default function EditAccount() {
  // register form
  const [registerEmailState, setregisterEmailState] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const [registerPasswordState, setregisterPasswordState] = React.useState("");
  const [
    registerConfirmPasswordState,
    setregisterConfirmPasswordState,
  ] = React.useState("");
  const [registerCheckboxState, setregisterCheckboxState] = React.useState("");
  const [formValues, setFormValues] = React.useState({
    firstName:"",
    lastName:"",
    mobileNumber:"",
    email:""
  });
  const [data, setData] = React.useState([]);
  const [alert, setAlert] = React.useState(null);

 
  // function that returns true if value is email, false otherwise
  const verifyEmail = (value) => {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  };
  const hideAlert = () => {
    setAlert(null);
    window.location.assign("/admin/dashboard");
  };

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.id]: e.target.value,
    });
    console.log(formValues);
  };

  React.useEffect(() => {
    const fetchData = async () =>{
      const token = localStorage.getItem("token");
      setLoading(true);
      try {

        await axios
        .get(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/account`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }).then((res) => {
          const data = res.data.data;
          setFormValues({
            firstName:data.firstName,
            lastName:data.lastName,
            mobileNumber:data.mobileNumber,
            email:data.email
          });
        })
      }
      catch (error) {
        console.error(error.message);
        if(error?.response?.data?.message=="For security reasons, we locked your account.Please login to continue"){
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        }
      }
      setLoading(false);
    }

    fetchData();
  }, []);

  const handleSubmit = async () => {
    const token = localStorage.getItem("token");
    axios.put(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/account`,
        
          formValues,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Access-Control-Allow-Origin": "*",
            }
        }

    ).then((res) => {
      setAlert(
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={
            <span
              style={{
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              {res.data.message}
            </span>
          }
          onConfirm={() => hideAlert()}
          onCancel={() => hideAlert()}
          titleCssClass={classesSweetAlert.cardTitle}
          confirmBtnCssClass={
            classesSweetAlert.button + " " + classesSweetAlert.success
          }
        />
      );
    })
        .catch((err) => {
            console.warn(err);
        })
}
  
 
  const classes = useStyles();
  const classesSweetAlert = useStyleData();
  return (
    <div>
    {loading && <div>Loading</div>}
    {!loading && (
    <GridContainer>
      <GridItem xs={12} sm={12} md={6}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Edit Account</h4>
          </CardHeader>
          <CardBody>
            <form>
            <CustomInput
                success={registerEmailState === "success"}
                error={registerEmailState === "error"}
                labelText="First Name *"
                id="firstName"
                handleChange={handleChange}
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  onChange: (event) => {
                    if (verifyEmail(event.target.value)) {
                      setregisterEmailState("success");
                    } else {
                      setregisterEmailState("error");
                    }
                    setregisterEmail(event.target.value);
                  },
                  type: "text",
                  value: formValues?.firstName,
                }}
              />
              <CustomInput
                success={registerEmailState === "success"}
                error={registerEmailState === "error"}
                labelText="Last Name *"
                id="lastName"
                handleChange={handleChange}
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  onChange: (event) => {
                    if (verifyEmail(event.target.value)) {
                      setregisterEmailState("success");
                    } else {
                      setregisterEmailState("error");
                    }
                    setregisterEmailState(event.target.value);
                  },
                  type: "text",
                  value: formValues?.lastName,
                }}
              />
              <CustomInput
                success={registerEmailState === "success"}
                error={registerEmailState === "error"}
                labelText="Email Address *"
                id="email"
                handleChange={handleChange}
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  onChange: (event) => {
                    if (verifyEmail(event.target.value)) {
                      setregisterEmailState("success");
                    } else {
                      setregisterEmailState("error");
                    }
                    setregisterEmail(event.target.value);
                  },
                  type: "email",
                  value: formValues?.email,
                }}
              />
              <CustomInput
                success={registerEmailState === "success"}
                error={registerEmailState === "error"}
                labelText="Phone Number *"
                id="mobileNumber"
                formControlProps={{
                  fullWidth: true,
                }}
                handleChange={handleChange}
                inputProps={{
                  onChange: (event) => {
                    if (verifyEmail(event.target.value)) {
                      setregisterEmailState("success");
                    } else {
                      setregisterEmailState("error");
                    }
                    setregisterEmail(event.target.value);
                  },
                  type: "number",
                  value: formValues?.mobileNumber,
                }}
              />
              <div className={classes.formCategory}>
                <small>*</small> Required fields
              </div>
              <Button
                color="rose"
                onClick={handleSubmit}
                className={classes.registerButton}
              >
                Register
              </Button>
            </form>
          </CardBody>
        </Card>
      </GridItem>
      {alert}
    </GridContainer>
    )}
    </div>
  );
}
